import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFeatureFlags } from 'utils/features';
import useLegacySettingsNavigation from './useLegacySettingsNavigation';

export default function useDailySignatureSettingNavigation() {
  const toggle = useFeatureFlags('SETTINGS');
  const location = useLocation();
  const navigate = useNavigate();

  const legacyNavigation = useLegacySettingsNavigation();
  const settingsNavigation = useCallback(() => {
    navigate({ pathname: '/settings/daily-sign-in-out' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  if (toggle) {
    return settingsNavigation;
  } else {
    return legacyNavigation;
  }
}
